export default __webpack_public_path__ + "static/media/author.458c6a8a.png";